<template>
  <div class="announcement">
    <div class="section hero-grey">
      <div class="container">
        <div class="center">
          <h2 class="h2 margin">
            Compulsas
          </h2>
        </div>
      </div>
    </div>

    <div class="section padding-bottomss">
      <div class="container">
        <h3 class="h2 margin">Compulsas publicadas</h3>

        <div data-duration-in="300" data-duration-out="100" class="tabs w-tabs">
          <div class="tabs-content w-tab-content">
            <div class="w-tab-pane">
              <div class="main-container">
                <div class="card-container" v-if="compulsas.length > 0">
                  <div
                    class="card"
                    style="display: block;"
                    v-for="(compulsa, i) in compulsas"
                    :key="i"
                    :class="i == 0 ? 'card_bg' : ''"
                  >
                    <small class="textss">
                      Fecha:
                      {{ compulsa.fecha | formatdate }}
                    </small>

                    <h5 class="card__titles">
                      {{ compulsa.cite }}
                      <br />
                    </h5>

                    <p class="card_description margins">
                      {{ compulsa.descripcion }}
                    </p>

                    <p class="card__applys">
                      <a
                        :href="`${serve}/compulsas/${compulsa.documento}`"
                        class="btn-download text-small"
                        target="_blank"
                        download
                      >
                        Descargar
                        <i class="fas fa-arrow-right"></i>
                      </a>
                    </p>
                  </div>
                </div>

                <div class="card-container" v-else-if="!loading">
                  <div class="alert">
                    <span class="text-red">
                      No existen compulsas publicadas
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="loading" class="center">
          <p>Cargando compulsas...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Service from "../router/endpoint";
import axios from "axios";

export default {
  name: "compulsas",

  data() {
    return {
      loading: false,
      compulsas: [],
      serve: "",
    };
  },

  mounted() {
    this.serve = Service.getServe();
    this.getCompulsas();
  },

  methods: {
    getCompulsas() {
      this.loading = true;

      axios
        .get(Service.getBase() + "lista/compulsas", Service.getHeader())
        .then((response) => {
          this.compulsas = response.data.data || response.data || [];
        })
        .catch((error) => {
          console.error("Error al cargar compulsas", error);
          this.compulsas = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>